import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';

export default class PhrasesList extends Component {
	constructor(props) {
	    super(props);
		this.state = {
			selectedPhrases:
				CommonFunctions.filterPhrases(this.props.app.phrases)
						.map(v => v[0])
						.filter(v =>
						!this.props.app.unselectedPhrases.includes(v)) };
	}

	componentDidMount() {
		setTimeout(() => {
				document.getElementById('phrases-table').parentNode.focus();
			}, 300);
	}

	selectAll() {
		let phrases = CommonFunctions.filterPhrases(this.props.app.phrases)
				.map(v => v[0]);
		this.setUnselectedPhrases(phrases);
		this.setState({ selectedPhrases: phrases });
	}

	selectNothing() {
		this.setUnselectedPhrases([]);
		this.setState({ selectedPhrases: [] });
	}

	setUnselectedPhrases(selectedPhrases) {
		this.props.app.unselectedPhrases =
				CommonFunctions.filterPhrases(this.props.app.phrases)
				.map(v => v[0])
				.filter(v => !selectedPhrases.includes(v));
	}

	onTdClick(event) {
		let p = event.currentTarget.parentNode;
		if (!('phraseIndex' in p.dataset)) return;
		let phrase = this.phrases[p.dataset.phraseIndex][0];
		let phrases = this.state.selectedPhrases.slice(0);
		let i = phrases.indexOf(phrase);
		if (i === -1) phrases.push(phrase); else phrases.splice(i, 1);
		this.setUnselectedPhrases(phrases);
		this.setState({ selectedPhrases: phrases });
	}

	onTdMouseDown(event) {
		event.preventDefault();
		this.props.app.enablePhrasesSelection = true;
		event.currentTarget.parentNode.parentNode.parentNode.parentNode.focus();
	}

	onTdMouseNove(event) {
		if (!this.props.app.enablePhrasesSelection) return;
		let p = event.currentTarget.parentNode;
		if (!('phraseIndex' in p.dataset)) return;
		let phrase = this.phrases[p.dataset.phraseIndex][0];

		if (event.ctrlKey) {
			if (this.state.selectedPhrases.includes(phrase)) {
				let phrases = this.state.selectedPhrases.slice(0);
				phrases.splice(phrases.indexOf(phrase), 1);
				this.setUnselectedPhrases(phrases);
				this.setState({ selectedPhrases: phrases });
			}
			return;
		}

		if (!this.state.selectedPhrases.includes(phrase)) {
			let phrases = this.state.selectedPhrases.slice(0);
			phrases.push(phrase);
			this.setUnselectedPhrases(phrases);
			this.setState({ selectedPhrases: phrases });
		}
	}

	render() {
		this.phrases = CommonFunctions.filterPhrases(this.props.app.phrases);
		return (
			<table id="phrases-table">
				<tbody>
					{
						this.phrases.map((v, i) => {
	let isSelected = this.state.selectedPhrases.includes(v[0]);
	let style = { cursor: 'default' };
	if (!isSelected) style.color = 'gray';
	return (
		<tr key={i} data-phrase-index={i}>
			<td
					align='center'
					style={{ paddingLeft: 5, paddingRight: 5 }}
					onClick={event => { this.onTdClick(event); }}
					onMouseDown={event => { this.onTdMouseDown(event); }}
					onMouseMove={event => { this.onTdMouseNove(event); }}>
				<img
					src={isSelected ? 'check-on.png' : 'check-off.png' }
					alt=''/>
			</td>
			<td
					style={style}
					onClick={event => {
						CommonFunctions.speak(event.currentTarget.innerText); }}
					onMouseDown={event => { this.onTdMouseDown(event); }}
					onMouseMove={event => { this.onTdMouseNove(event); }}>
				{v[0]}
			</td>
			<td
					style={{
						color: 'green',
						cursor: 'default',
						paddingLeft: 15 }}
					onClick={event => { this.onTdClick(event); }}
					onMouseDown={event => { this.onTdMouseDown(event); }}
					onMouseMove={event => { this.onTdMouseNove(event); }}>
				{(v[1])}
			</td>
		</tr>);
						})
					}
				</tbody>
			</table>);
	} // render
} // class PhrasesList



// WEBPACK FOOTER //
// ./src/PhrasesList.js